// extracted by mini-css-extract-plugin
export default {"center":"Items_center__fgTRk","icon":"Items_icon__3qgAt","title":"Items_title__U6wTk","after":"Items_after__LtPbc"};